export default class GoogleMap {
  constructor() {
    this.canvas = document.getElementById('js-gmap');

    this.map = null;

    this.center = {
      lat: Number(this.canvas.dataset.lat),
      lng: Number(this.canvas.dataset.lng),
    };

    this.zoom = Number(this.canvas.dataset.zoom);

    this.mapType = new google.maps.StyledMapType([
      {
        "stylers": [
          {"saturation": -100}
        ]
      }
    ]);

    this.cutomMakerIcons = document.getElementById('marker-icon') ?  document.getElementById('marker-icon').innerHTML : '';

    const dataPins = this.canvas.dataset.pins;

    this.pins = dataPins ? JSON.parse(dataPins) : [];

    this.init();
  }

  init() {
    this.map = new google.maps.Map(this.canvas, {
      center: this.center,
      zoom: this.zoom,
      scrollwheel: false,
    });

    this.map.mapTypes.set('GrayScaleMap', this.mapType);
    this.map.setMapTypeId('GrayScaleMap');

    this.pins.forEach(v => {
      new google.maps.Marker({
        map: this.map,
        position: v,
        optimized: false,
        icon: {
          url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(this.cutomMakerIcons),
          scaledSize: new google.maps.Size(28.47, 40.03),
        },
      });
    });
  }
}
